import React from "react";
import { useSelector } from "react-redux";
import { selectUserName, selectUserPermissions } from "../features/auth/authSlice";
import { Navigate } from "react-router-dom";

export default function Resolve() {
  // If logged in, go to the home page
  if (useSelector(selectUserName) && useSelector(selectUserPermissions) !== 'pending') {
    return <Navigate replace to="home" />;
  }

  // Otherwise go to the login form
  return <Navigate replace to="login" />;
}
